import {z} from 'zod';

export const ACCOUNT_USER_RULES = [
  {label: 'Aluno', value: 'aluno'},
  {label: 'Coach', value: 'coach'},
  {label: 'Manager', value: 'manager'},
  {label: 'Admin', value: 'admin'},
];

export const NewAccountUserSchema = z.object({
  email: z.string().email({message: 'Informe um e-mail válido'}),
  name: z.string().optional(),
  lastName: z.string().optional(),
  rule: z.enum(['aluno', 'coach', 'manager', 'admin'], {
    errorMap: () => ({message: 'Escolha um papel válido'}),
  }),
});

export type NewAccountUserForm = z.infer<typeof NewAccountUserSchema>;
